import { TLocationManagement } from '@features/setting/location/state_management/types'
import axios from '@utils/axios-client'
import {
    ILiftModel
} from 'AppTypes'

class LiftAPI {
    prefix = '/api/v1/Lift'
 

    async fetchAll() {
        const url = `${this.prefix}/GetAll`;
        const response = await axios.get<{
            data: ILiftModel[]
        }>(url)
        return response;
    }

    async insert(params: TLocationManagement.BlockModel) {
        const url = `${this.prefix}/Create`
        return await axios.post(url, params)
    }

    async update(params: TLocationManagement.BlockModel) {
        const url = `${this.prefix}/Update`
        return await axios.put(url, params)
    }

     
    delete(id: string) {
        const url = `${this.prefix}/Delete?id=${id}`
        return axios.delete(url)
    }

    
}

export const liftAPI = new LiftAPI()